/** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */
/** @jsx jsx */
import type { ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import { HeadingItem } from '@atlaskit/side-navigation';
import { useSidebarTheme } from '../../../controllers/sidebar-theme/index.tsx';

const textColorCssVar = '--section-header-text-color';
const opacityCssVar = '--section-header-opacity';

const colorThemeStyles = css({
	// Need to increase specificity here until HeadingItem has been migrated to @compiled/react
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&&': {
		color: `var(${textColorCssVar})`,
	},
});

const opacityThemeStyles = css({
	// Need to increase specificity here until HeadingItem has been migrated to @compiled/react
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&&': {
		opacity: `var(${opacityCssVar})`,
	},
});

export type SectionHeaderProps = {
	children: ReactNode;
};

export const SectionHeader = ({ children }: SectionHeaderProps) => {
	const theme = useSidebarTheme();
	const item = theme?.navigation?.item;

	return (
		<HeadingItem
			// @ts-expect-error - className is a valid prop
			// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
			css={[item?.opacity && opacityThemeStyles, item?.color?.default && colorThemeStyles]}
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{
				[opacityCssVar]: item?.opacity,
				[textColorCssVar]: item?.color?.default,
			}}
		>
			{children}
		</HeadingItem>
	);
};
